<template>
  <div>
    <div
      class="relative flex mx-6 cursor-pointer"
      @click="handleShowNotificationDrawer"
    >
      <notification-icon class="h-8" />
      <div v-if="unReadNotificationsCount > 0" class="ntn_btn text-center">
        {{ unReadNotificationsCount }}
      </div>
    </div>
  </div>
</template>

<script>
import notification from '@/mixins/notification.js'

export default {
  mixins: [notification],
  data: () => ({
    isDrawerOpen: false
  }),
  components: {
    NotificationIcon: () => import('@/assets/v2/icons/NotificationIcon.vue')
  },
  methods: {
    handleShowNotificationDrawer () {
      this.isDrawerOpen = true
      this.$store.dispatch(
        'notification/setNotificationDrawer',
        this.isDrawerOpen
      )
    }
  },
  computed: {
    hasUnreadMessages () {
      return this.$store.state.common.unreadMessages
    }
  },
  mounted () {
    this.getUnreadNotifications()
  }
}
</script>
<style scoped>
.ntn_btn {
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  width: 12px;
  height: 12px;
  line-height: 12px;
  border-radius: 50%;
  font-size: 6px;
  color: #fff;
  text-align: center;
  background: #d71841;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 767px) {
  .ntn_btn {
    top: -4px;
    right: -2px;
  }
}
</style>
